import type { ReactNode } from 'react'
import styles from './PageTip.module.css'
import {
  EmptyState,
  EmptyStateActions,
  EmptyStateDescription,
  EmptyStateIllustration,
  EmptyStateTitle,
} from '@/components/EmptyState'
import { byDesign } from '@/infra/design'
import imgCreateJobUrl from '@/assets/misc/img_create-job.svg'
import CreateJobIllustration from '@/components/SpotIllustration/CreateJobIllustration'
import type { FittedIllustration } from '@/components/SpotIllustration/fitted-illustration'

interface PageTipProps {
  title: string
  illustrationUrl?: string
  /**
   * Shown instead of `illustrationUrl` when set.
   */
  illustration?: FittedIllustration
  button?: ReactNode
  children?: ReactNode
  /**
   * Hides the illustration, for workspaces in corporate mode.
   */
  corporateMode: boolean
}

/**
 * A tip with an illustration, shown when a page has no content yet.
 */
export function PageTip({
  title,
  illustrationUrl,
  illustration,
  button,
  children,
  corporateMode,
}: PageTipProps) {
  return (
    <div className={styles.root}>
      <div className={styles.box}>
        <EmptyState size="sm" pad>
          {!corporateMode && (
            <EmptyStateIllustration
              src={illustrationUrl ?? imgCreateJobUrl}
              illustration={
                illustration ??
                // A page's own image replaces the default in either design.
                (illustrationUrl
                  ? undefined
                  : byDesign(undefined, CreateJobIllustration))
              }
            />
          )}
          <EmptyStateTitle>{title}</EmptyStateTitle>
          {children && (
            <EmptyStateDescription>{children}</EmptyStateDescription>
          )}
          {button && <EmptyStateActions>{button}</EmptyStateActions>}
        </EmptyState>
      </div>
    </div>
  )
}
